import { css } from "@emotion/react";

import { colors, dimensions, layers, timing } from "@styles";

const navHeight = "4.75rem";

export const mainNav = css`
  width: 100%;
  height: ${navHeight};
  background-color: ${colors.white};
  margin-right: 5rem;
  box-shadow: 0 2px 5px rgb(0 0 0 / 15%);
`;

export const mobileMenu = css`
  display: flex;
  align-items: center;
`;

export const flexNav = css`
  display: flex;
  align-items: flex-start;
`;

export const container = css`
  display: flex;
  height: 100%;
  justify-content: space-between;
  width: 100%;
  padding: 1.25rem;

  &&& {
    margin: 0;
    max-width: 100%;
    align-items: center;
  }
`;

export const sidebarToggle = css`
  background: none;
  border: none;
  cursor: pointer;
  padding: 1rem;
`;

export const hamburger = css`
  path {
    fill: ${colors.dark};
  }
`;

export const closeIconContainer = css`
  padding: 1rem;
  background: none;
  border: none;
  cursor: pointer;

  path {
    fill: ${colors.grey.darkFamily.dark};
  }

  button {
    height: inherit;
  }
`;

export const homeLink = css`
  display: inline-flex;
  align-items: center;
`;

export const navLogo = css`
  display: block;
  height: 1.25rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    height: 2.5rem;
  }
`;

export const navClosed = css`
  max-height: 0;
  transition: max-height ${timing.moderatelySlow} ease-out;
`;

export const navOpened = css`
  transition: all ${timing.moderatelySlow} ease-in;
  box-shadow: 0 2px 5px rgb(0 0 0 / 15%);
`;

export const nav = css`
  display: flex;
  align-items: flex-start;
  background-color: ${colors.white};
  width: 100%;
  z-index: ${layers.indexNavBarMax};
  position: sticky;
  overflow: hidden;
`;

export const mobileNavContainer = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 1.25rem;
  justify-content: flex-end;
`;

export const loginButton = css`
  border-radius: 0.5rem !important;
  &:hover {
    box-shadow: 0 4px 4px rgb(0, 0, 0, 25%) !important;
  }
  margin-right: 1.25rem;
`;
